import React from 'react'
import Carousel from 'react-multi-carousel';
import { Link } from 'react-router-dom';

export const Vision = () => {

  const supplyChainResponsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 1700, min: 1200 },
        items: 1
    },
    desktop: {
        breakpoint: { max: 1200, min: 992 },
        items: 1
    },
    tablet: {
        breakpoint: { max: 992, min: 768 },
        items: 1
    },
    mobile: {
        breakpoint: { max: 768, min: 0 },
        items: 1
    }
}


  return (
     <section className="about-one vision-section">
                    <div className='container-fluid p-0'>
                        <div className='row'>
                            <div className='col-lg-5' >
                                {/* <Carousel arrows={false}
                                    responsive={supplyChainResponsive}
                                    infinite={true}
                                    showDots={false}
                                    autoPlay={true}
                                
                                    >
                                   
                                        <div className="swiper-slide position-relative">
                                            <img src="/images/resources/about-2.png" alt="" />
                                        </div>
                                      
                                </Carousel> */}
                                <img src="/images/mission-vision/vision.jpg" alt="" />
                            </div>
                            <div className='col-lg-7'>
                               
                                    <div className='section-title text-left'>
                                        <div className="section-title__tagline-box">
                                            <span className="section-title__tagline">Our Vision</span>
                                        </div>
                                        <p className="about-one__text">We aspire to create a world where… global connectivity fuels sustainable growth, prosperity and harmony. We aim to overcome geographical barriers, stimulate innovation and uplift communities, there by shaping a brighter future for generations to come.</p>
                                        <Link to='/membership-registration' class="thm-btn main-menu__btn mt-5">Grow with us<span class="omaga"></span></Link>
                                    </div>
                                
                            </div>
                        </div>
                    </div>
                    </section>
  )
}
